import React, { useContext, useState } from 'react';
import { Icon as BlueIcon } from '@blueprintjs/core';

import {
  createState,
  useHookstate,
  useState as hookUseState,
} from '@hookstate/core';
import SerachClearIcon from '@assets/svg/search-clear.svg';
import { IStudios } from '@models/Studios.model';
import {
  CurrentFilter,
  CurrentFilterTitle,
  CurrentItem,
  InitialSearchedItem,
  InitialSearchedItems,
  Item,
  ItemText,
  SearchButton,
  SearchClear,
  SearchInput,
  SearchWrapper,
  Separator,
} from '../../Filter.styles';
import { FilterContext } from '../../Filter.query';

export const filterState = createState<string>('');

export const currentFilterState = createState<string>('');
interface IFilterItem {
  item_text: string;
  item_searched_data?: IStudios[];
  onClickItem: () => void;
}

export const FilterItem = ({
  item_text,
  item_searched_data,
  onClickItem,
}: IFilterItem) => {
  const [dropdown, setDropdown] = useState<boolean>(false);

  const searchLocal = hookUseState<string>('');
  const searchEdited = hookUseState<boolean>(false);

  const { searchValue } = useContext(FilterContext);

  const assetFilter = useHookstate(filterState);

  const currentFilter = useHookstate(currentFilterState);

  const searchState =
    searchValue.get() !== searchLocal.get() || searchEdited.get();

  const clearState =
    searchValue.get() === searchLocal.get() &&
    searchLocal.get() !== '' &&
    !searchEdited.get();

  const callSearch = () => {
    searchValue.set(searchLocal.get());
    searchEdited.set(false);
  };

  const clearSearch = () => {
    searchLocal.set('');
    searchValue.set('');
    searchEdited.set(false);
  };

  return (
    <>
      <Item onClick={() => setDropdown(!dropdown)}>
        <ItemText>{item_text}</ItemText>
        {dropdown ? (
          <BlueIcon icon="chevron-down" color="#8F95B2" />
        ) : (
          <BlueIcon icon="chevron-right" color="#8F95B2" />
        )}
      </Item>
      {dropdown && (
        <>
          <SearchWrapper>
            <SearchInput
              placeholder={`Find a ${item_text}`}
              value={searchLocal.get()}
              onChange={e => {
                searchLocal.set(e.target.value);
                searchEdited.set(true);

                searchLocal.get().length < 1 && clearSearch();
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  callSearch();
                }
              }}
            />

            {searchState && (
              <SearchButton onClick={callSearch}>Search</SearchButton>
            )}
            {clearState && (
              <SearchClear onClick={clearSearch}>
                <img src={SerachClearIcon} alt="clear" />
              </SearchClear>
            )}
          </SearchWrapper>

          {currentFilter.get() && (
            <CurrentFilter>
              <CurrentFilterTitle>Current</CurrentFilterTitle>
              <CurrentItem>
                {currentFilter.get()}
                <BlueIcon
                  icon="cross"
                  color="red"
                  size={12}
                  onClick={() => {
                    onClickItem();
                    assetFilter.set('');
                    currentFilter.set('');
                  }}
                />
              </CurrentItem>
              <Separator />
            </CurrentFilter>
          )}

          <InitialSearchedItems>
            {item_searched_data &&
              item_searched_data
                .filter(item => item.studioName !== currentFilter.get())
                .map(asset => (
                  <InitialSearchedItem
                    key={asset.id}
                    onClick={() => {
                      assetFilter.set(asset.id);
                      currentFilter.set(asset.studioName);
                      onClickItem();
                      setDropdown(false);
                    }}
                  >
                    {asset.studioName}
                  </InitialSearchedItem>
                ))}
          </InitialSearchedItems>
        </>
      )}
    </>
  );
};
